<!-- venter på https://github.com/angular/angular/pull/55880 for [formArray] støtte -->
<form [formGroup]="skjema">
    <span class="ramme-tittel">{{ "Forslag til beslutning"|translate }}</span>

    @for (kontroller of skjema.controls; track indeks; let indeks = $index;) {
      <div [formGroup]="kontroller" [ngClass]="{'tom-rad':erTomRad(kontroller), 'slettet': kontroller.value.slettet}" class="beslutning e2e-beslutning" data-testid="beslutning">
        <i class="lederplan-ikon-beslutning"></i>
        <fieldset>
          <mat-form-field class="tittel">
            <mat-label>
              @if(kontroller.value.ny){
                {{ "Nytt beslutningsforslag"|translate }}
              } @else {
                {{ "Beslutningsforslag"|translate }}
              }
            </mat-label>
            <textarea matInput
                      formControlName="tittel"
                      class="e2e-tittel"
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="1"
                      cdkAutosizeMaxRows="3"
                      data-testid="tittel"></textarea>
            @if(kontroller.controls.tittel.hasError('maxlength')){
              <mat-error data-testid="maxlength">{{kontroller.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
            }
            @if(kontroller.controls.tittel.hasError('required')) {
              <mat-error>{{ "Tittel må være fylt ut"|translate }}</mat-error>
            }
            @if(kontroller.controls.tittel.hasError('tittelOgBeskrivelseTom')) {
              <mat-error>{{ "Tittel eller beskrivelse må være fylt ut"|translate }}</mat-error>
            }
          </mat-form-field>
          <mat-form-field class="beskrivelse">
            <mat-label>{{ "Beslutningsforslag - utdyping"|translate }}</mat-label>
            <riktekst-redigering [skjemakontroll]="kontroller.controls.beskrivelse" [gruppeId]="gruppeId()" innholdBrukesIPdf="true" class="e2e-beskrivelse"/>
          </mat-form-field>
        </fieldset>
        @if (kontroller.controls.slettet.value) {
          <!-- raden er slettet - viser knapp for å "angre" -->
          <button (click)="angreSlett(indeks)" mat-button type="button" aria-label="Angre sletting av forslag til beslutning" class="slett" data-testid="angre-slett">
            {{ "Angre slett"|translate }}
          </button>
        } @else {
          <!-- raden er IKKE slettet - viser knapp for å "slette" -->
          <button (click)="slett(indeks)" mat-icon-button type="button" aria-label="Slett forslag til beslutning" class="slett mat-medium-icon-button e2e-slett" data-testid="slett">
            <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
          </button>
        }
      </div>
    }

</form>
